export default "__VITE_ASSET__DSIG5H8M__"